import { t } from '../../../../../services/texts.service';
import { ISettings } from '../../models/settings.model';
import { StopAreaType } from '../../models/stop-area-type.enum';
import SelectStopAreas from '../Settings/components/SelectStopAreas';

export default function Welcome({ mySettings, onChange }: { mySettings: ISettings; onChange: (settings: ISettings) => void }) {
  // === RENDERING ===
  return (
    <div>
      <h2>{t('Välj dina hållplatser', 'Choose your stop areas')}</h2>
      <p>{t('När du har valt hållplatser kan du se en översikt för din resa.', 'Once you have chosen stop areas, you can see an overview of your journey.')}</p>
      <div>
        <SelectStopAreas
          type={StopAreaType.Home}
          stopAreas={mySettings.homeStopAreas}
          className="mb-3"
          singleStopArea={true}
          onSave={(stopAreas) => onChange({ ...mySettings, homeStopAreas: stopAreas })}
        />
        <SelectStopAreas
          type={StopAreaType.Work}
          stopAreas={mySettings.workStopAreas}
          className="mb-0"
          singleStopArea={true}
          onSave={(stopAreas) => onChange({ ...mySettings, workStopAreas: stopAreas })}
        />
      </div>
    </div>
  );
}
